import { RequestOptions } from './request-options';

export class MenuRequest extends RequestOptions {
    Id_Plan: number;
    Id_Stage: number;
    N_day: number;
    N_Part: number;
    Id_Recipe: number;
    CalculationWeight: number;
    TypeMenu: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/menu-request.ts